export default __webpack_public_path__ + "static/media/SndLowerBDiveDown.9af67018.mp3";